import { cn } from "../cn.ts";

export function LoadingSkeleton({ className }: { className?: string }) {
  return (
    <div
      role="status"
      aria-busy="true"
      className={cn("motion-safe:animate-pulse rounded-lg bg-[var(--brand-pink-soft)]", className)}
    />
  );
}

export function VerticalPosterSkeleton({ count = 6 }: { count?: number }) {
  return (
    <div className="flex gap-3 overflow-hidden">
      {Array.from({ length: count }, (_, i) => (
        <LoadingSkeleton key={i} className="aspect-poster w-[160px] shrink-0" />
      ))}
    </div>
  );
}
